import { render } from "./WritingTranslation.vue?vue&type=template&id=692a3e73&scoped=true"
import script from "./WritingTranslation.vue?vue&type=script&lang=js"
export * from "./WritingTranslation.vue?vue&type=script&lang=js"

import "./WritingTranslation.vue?vue&type=style&index=0&id=692a3e73&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692a3e73"]])

export default __exports__